module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.userReady) ? _c('div', {
    staticClass: "container"
  }, [_c('core-header', {
    attrs: {
      "fromDashboard": true,
      "user": _vm.user,
      "showMode": _vm.showMode,
      "isActivePay": _vm.user.active_pay
    },
    on: {
      "toggleShowMode": _vm.toggleShowMode
    }
  }), _vm._v(" "), _c('core-nav-main', {
    attrs: {
      "user": _vm.user
    }
  }), _vm._v(" "), (_vm.isInitialProjectLoading) ? _c('md-layout', {
    staticClass: "newProjectLoadingBox md-gutter-16",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "md-align": "center",
      "md-row": "",
      "md-flex": "100"
    }
  }, [_c('md-progress', {
    attrs: {
      "md-indeterminate": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sample-project-loading-message"
  }, [_vm._v("Setting up your first project. This will only take a moment...")])], 1) : _vm._e(), _vm._v(" "), (_vm.projectsReady) ? _c('div', {
    staticClass: "dashboard"
  }, [(_vm.hasUnusedShowPass) ? _c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center",
      "gap": "12px",
      "background": "#0d2744",
      "color": "#fff",
      "border-radius": "4px",
      "padding": "12px 16px",
      "margin": "20px 0 16px"
    }
  }, [_c('svg', {
    staticStyle: {
      "flex": "none",
      "display": "block"
    },
    attrs: {
      "width": "20",
      "height": "20",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-linejoin": "round",
      "stroke-linecap": "round",
      "aria-hidden": "true"
    }
  }, [_c('path', {
    attrs: {
      "stroke-width": "1.6",
      "d": "M4 5H20A2 2 0 0 1 22 7V9.5A2.5 2.5 0 0 0 22 14.5V17A2 2 0 0 1 20 19H4A2 2 0 0 1 2 17V14.5A2.5 2.5 0 0 0 2 9.5V7A2 2 0 0 1 4 5Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "stroke-width": "1.3",
      "stroke-dasharray": "1.4 1.8",
      "d": "M15.6 6.4V17.6"
    }
  })]), _vm._v(" "), _c('span', {
    staticStyle: {
      "flex": "1",
      "font-size": "14px",
      "line-height": "1.35"
    }
  }, [_vm._v("\n                You have " + _vm._s(_vm.showPassCount) + " Show Pass" + _vm._s(_vm.showPassCount > 1 ? 'es' : '') + " ready. "), _c('strong', [_vm._v("Start a new project")]), _vm._v(" to activate " + _vm._s(_vm.showPassCount > 1 ? 'one' : 'it') + " and invite your whole team to edit it.\n                "), _vm._v(" "), _c('span', {
    staticStyle: {
      "display": "block",
      "margin-top": "4px",
      "opacity": ".85"
    }
  }, [_vm._v("To use " + _vm._s(_vm.showPassCount > 1 ? 'one' : 'it') + " on an existing project, open that show and choose “Use your Show Pass on this show” from the Project Settings menu.")])]), _vm._v(" "), _c('button', {
    staticClass: "showpass-activate-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.openCreateProject(true)
      }
    }
  }, [_vm._v("Activate Show Pass")])]) : _vm._e(), _vm._v(" "), (!_vm.hasUnusedShowPass && _vm.needsConsentAnswer) ? _c('div', {
    staticClass: "consent-banner"
  }, [_c('svg', {
    staticClass: "cb-icon",
    attrs: {
      "width": "22",
      "height": "22",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.6",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "aria-hidden": "true"
    }
  }, [_c('path', {
    attrs: {
      "d": "M3 6.5h18v11H3z"
    }
  }), _c('path', {
    attrs: {
      "d": "m3 7 9 6 9-6"
    }
  })]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('span', {
    staticClass: "cb-actions"
  }, [_c('button', {
    staticClass: "cb-btn cb-yes",
    attrs: {
      "type": "button",
      "disabled": _vm.consentSaving
    },
    on: {
      "click": function($event) {
        return _vm.answerConsent(true)
      }
    }
  }, [_vm._v("Yes, keep me posted")]), _vm._v(" "), _c('button', {
    staticClass: "cb-btn cb-no",
    attrs: {
      "type": "button",
      "disabled": _vm.consentSaving
    },
    on: {
      "click": function($event) {
        return _vm.answerConsent(false)
      }
    }
  }, [_vm._v("No thanks")])])]) : _vm._e(), _vm._v(" "), (!_vm.hasAnyProjects) ? _c('div', {
    staticClass: "dash-empty"
  }, [(_vm.user.active_pay) ? _c('button', {
    staticClass: "ql-btn ql-btn--primary btn-start-project",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.openCreateProject()
      }
    }
  }, [_vm._v("Start your first Project")]) : _c('button', {
    staticClass: "ql-btn ql-btn--primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.upgradeSubscription
    }
  }, [_vm._v("Upgrade Account")])]) : [(_vm.newProjectLoading || _vm.newDuplicateProjectLoading) ? _c('md-layout', {
    staticClass: "newProjectLoadingBox md-gutter-16",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "md-flex": "100"
    }
  }, [_c('md-progress', {
    attrs: {
      "md-indeterminate": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "newProjectLoadingBox-Message"
  }, [_vm._v("Your request is running in the background. Please be patient while it completes. Avoid closing or refreshing the page.")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dash-columns"
  }, [_c('div', {
    staticClass: "dash-main"
  }, [_c('dashboard-toolbar', {
    attrs: {
      "tab": _vm.effectiveTab,
      "viewMode": _vm.viewMode,
      "sort": _vm.sort,
      "hasShared": _vm.hasSharedProjects
    },
    on: {
      "tabChange": _vm.onTabChange,
      "viewChange": _vm.onViewChange,
      "sortChange": _vm.setSort
    }
  }), _vm._v(" "), (_vm.tabIsEmpty) ? _c('div', {
    staticClass: "dash-tab-empty"
  }, [_c('p', [_vm._v("No projects in this view.")])]) : [(_vm.pinnedDisplay.length) ? _c('dashboard-section', {
    key: "pinned",
    attrs: {
      "title": "Pinned",
      "icon": "push_pin",
      "projects": _vm.pinnedDisplay,
      "viewMode": _vm.viewMode,
      "sort": _vm.sort
    },
    on: {
      "sortChange": _vm.toggleSort,
      "projectAccepted": _vm.handleProjectAccepted,
      "projectDeleted": _vm.handleProjectDeleted
    }
  }) : _vm._e(), _vm._v(" "), _c('dashboard-section', {
    key: "recent",
    attrs: {
      "title": "Recent",
      "icon": "schedule",
      "projects": _vm.recentDisplay,
      "viewMode": _vm.viewMode,
      "sort": _vm.sort,
      "showViewMore": !_vm.allProjectsLoaded,
      "loadingMore": _vm.loadingMore
    },
    on: {
      "sortChange": _vm.toggleSort,
      "viewMore": _vm.loadMoreProjects,
      "projectAccepted": _vm.handleProjectAccepted,
      "projectDeleted": _vm.handleProjectDeleted
    }
  })]], 2), _vm._v(" "), _c('div', {
    staticClass: "dash-side"
  }, [(_vm.user.active_pay) ? _c('button', {
    staticClass: "ql-btn ql-btn--primary dash-side-cta",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.openCreateProject()
      }
    }
  }, [_vm._v("Start a New Project")]) : _c('button', {
    staticClass: "ql-btn ql-btn--primary dash-side-cta",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.upgradeSubscription
    }
  }, [_vm._v("Upgrade Account")]), _vm._v(" "), (_vm.userPendingProjectsData) ? _c('dashboard-pending-projects', {
    attrs: {
      "userPendingProjectsData": _vm.userPendingProjectsData,
      "user": _vm.user
    },
    on: {
      "projectAccepted": _vm.handleProjectAccepted
    }
  }) : _vm._e(), _vm._v(" "), (_vm.userPendingProjectsData) ? _c('dashboard-pending-affiliations', {
    attrs: {
      "pendingReady": _vm.affiliateInvitesReady,
      "user": _vm.user
    },
    on: {
      "affiliationAccepted": _vm.handleAffiliationAccepted
    }
  }) : _vm._e()], 1)])]], 2) : _c('div', {
    staticClass: "dashboard"
  }, [_c('div', {
    staticClass: "loading-msg",
    staticStyle: {
      "display": "flex",
      "flex-direction": "column",
      "align-items": "center"
    }
  }, [_c('span', {
    staticClass: "md-subheader"
  }, [_c('svg', {
    staticStyle: {
      "height": "56px",
      "margin-top": "72px"
    },
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 200 200"
    }
  }, [_c('circle', {
    attrs: {
      "fill": "#73D5E3",
      "stroke": "#73D5E3",
      "stroke-width": "15",
      "r": "15",
      "cx": "40",
      "cy": "65"
    }
  }, [_c('animate', {
    attrs: {
      "attributeName": "cy",
      "calcMode": "spline",
      "dur": "2",
      "values": "65;135;65;",
      "keySplines": ".5 0 .5 1;.5 0 .5 1",
      "repeatCount": "indefinite",
      "begin": "-.4"
    }
  })]), _c('circle', {
    attrs: {
      "fill": "#73D5E3",
      "stroke": "#73D5E3",
      "stroke-width": "15",
      "r": "15",
      "cx": "100",
      "cy": "65"
    }
  }, [_c('animate', {
    attrs: {
      "attributeName": "cy",
      "calcMode": "spline",
      "dur": "2",
      "values": "65;135;65;",
      "keySplines": ".5 0 .5 1;.5 0 .5 1",
      "repeatCount": "indefinite",
      "begin": "-.2"
    }
  })]), _c('circle', {
    attrs: {
      "fill": "#73D5E3",
      "stroke": "#73D5E3",
      "stroke-width": "15",
      "r": "15",
      "cx": "160",
      "cy": "65"
    }
  }, [_c('animate', {
    attrs: {
      "attributeName": "cy",
      "calcMode": "spline",
      "dur": "2",
      "values": "65;135;65;",
      "keySplines": ".5 0 .5 1;.5 0 .5 1",
      "repeatCount": "indefinite",
      "begin": "0"
    }
  })])])]), _vm._v(" "), _c('span', {
    staticClass: "md-subheader"
  }, [_vm._v("Loading your projects...")])])]), _vm._v(" "), _c('create-project', {
    ref: "createProject",
    on: {
      "projectAccepted": _vm.handleProjectAccepted
    }
  }), _vm._v(" "), _c('upgrade-account', {
    ref: "upgradeAcct"
  }), _vm._v(" "), _c('maintenance-notice', {
    ref: "maintenanceNotice"
  }), _vm._v(" "), _c('core-footer')], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "cb-copy"
  }, [_c('strong', {
    staticClass: "cb-q"
  }, [_vm._v("Want updates about Cuelist?")]), _vm._v(" "), _c('span', {
    staticClass: "cb-sub"
  }, [_vm._v("Occasional email about new features, nothing else. "), _c('strong', [_vm._v("Answer either way and we won’t ask again")]), _vm._v(" — you can change it any time in your account settings.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7a6f96b7","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/dashboard.vue
// module id = 1268
// module chunks = 21